import AccountList from "@core-components/accountDisplay/components/AccountList";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import AppSkeleton from "@modules/loader/AppSkeleton";
import AppSkeletonProductCard from "./AppSkeletonProductCard";

interface IAppSkeletonBuyCardListProps {
  length?: number;
}

const AppSkeletonBuyCardList: React.FC<IAppSkeletonBuyCardListProps> = ({
  length = 4,
}) => {
  return (
    <>
      <AccountList
        label={
          <AppSkeleton>
            <SSWhiteText> NOS COMPTE SMURFS </SSWhiteText>
            <SSLoLGradientText>MONTÉS MAINS</SSLoLGradientText>
            <SSWhiteText> ENGLISH LABEL </SSWhiteText>
          </AppSkeleton>
        }
      >
        {Array(length)
          .fill(0)
          .map((_, i) => (
            <AppSkeletonProductCard key={i} />
          ))}
      </AccountList>
    </>
  );
};

export default AppSkeletonBuyCardList;
